// extracted by mini-css-extract-plugin
export default {"projects":"styles_projects__mALkI"};